module.exports = __webpack_public_path__ + "static/summer-sale-overlay-0079796032585ff7158727dc60c41754.png";